var _g, _path, _path2, _rect, _g2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedalWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 119,
    viewBox: "0 0 110 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27986_42701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8717 11.5159L19.9556 28.376C16.2678 30.5262 14 34.4737 14 38.7426V72.2574C14 76.5263 16.2678 80.4738 19.9556 82.624L48.8717 99.4841C52.5993 101.658 57.2068 101.662 60.9389 99.4967L90.0228 82.6199C93.7228 80.4729 96 76.5186 96 72.2408V38.7592C96 34.4814 93.7228 30.5271 90.0228 28.3801L60.9389 11.5033C57.2068 9.33763 52.5993 9.34244 48.8717 11.5159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8717 11.5159L19.9556 28.376C16.2678 30.5262 14 34.4737 14 38.7426V72.2574C14 76.5263 16.2678 80.4738 19.9556 82.624L48.8717 99.4841C52.5993 101.658 57.2068 101.662 60.9389 99.4967L90.0228 82.6199C93.7228 80.4729 96 76.5186 96 72.2408V38.7592C96 34.4814 93.7228 30.5271 90.0228 28.3801L60.9389 11.5033C57.2068 9.33763 52.5993 9.34244 48.8717 11.5159Z",
    stroke: "#ECE9F8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5337 17.0146L25.3894 31.1958C21.7203 33.3508 19.4668 37.2878 19.4668 41.543V69.8966C19.4668 74.1518 21.7203 78.0888 25.3894 80.2438L49.5337 94.425C53.2779 96.6242 57.9181 96.629 61.6669 94.4377L85.9559 80.2399C89.6372 78.088 91.9001 74.1441 91.9001 69.8799V41.5597C91.9001 37.2955 89.6372 33.3517 85.9559 31.1998L61.6669 17.0019C57.9181 14.8106 53.2779 14.8155 49.5337 17.0146Z",
    fill: "#E5B428"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7325 22.654L30.723 33.5459C27.1291 35.7195 24.9331 39.6139 24.9331 43.8141V66.262C24.9331 70.4621 27.1291 74.3565 30.723 76.5301L48.7325 87.422C52.5427 89.7264 57.3157 89.7315 61.1308 87.4352L79.2547 76.5265C82.861 74.3559 85.0664 70.4544 85.0664 66.2452V43.8308C85.0664 39.6216 82.861 35.7202 79.2547 33.5495L61.1308 22.6409C57.3157 20.3446 52.5427 20.3496 48.7325 22.654Z",
    fill: "#FED253"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27986_42701",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 21,
    width: 31,
    height: 68
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.9331,
    y: 21.6343,
    width: 30.0667,
    height: 66.8079,
    fill: "#A7DDE0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27986_42701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7325 22.654L30.723 33.5459C27.1291 35.7195 24.9331 39.6139 24.9331 43.8141V66.262C24.9331 70.4621 27.1291 74.3565 30.723 76.5301L48.7325 87.422C52.5427 89.7264 57.3157 89.7315 61.1308 87.4352L79.2547 76.5265C82.861 74.3559 85.0664 70.4544 85.0664 66.2452V43.8308C85.0664 39.6216 82.861 35.7202 79.2547 33.5495L61.1308 22.6409C57.3157 20.3446 52.5427 20.3496 48.7325 22.654Z",
    fill: "#FDCA37"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6755 72.1216C65.1912 72.1216 72.9053 64.4076 72.9053 54.8918C72.9053 45.3761 65.1912 37.6621 55.6755 37.6621C46.1598 37.6621 38.4458 45.3761 38.4458 54.8918C38.4458 64.4076 46.1598 72.1216 55.6755 72.1216Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6758 48V54.8919",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6758 61.7837H55.6939",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27986_42701",
    x: 0.5,
    y: 0.382324,
    width: 109,
    height: 118.235,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_27986_42701"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.266667 0 0 0 0 0.168627 0 0 0 0 0.54902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27986_42701"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27986_42701",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalWarning);
export default __webpack_public_path__ + "static/media/medal-warning.e6541cd946771a1f1c9f5045f7e0bbbf.svg";
export { ForwardRef as ReactComponent };